import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors, spacing, borderRadius, typography } = useTheme();

  return {
    matchDetailsWrapper: (hasAddress) => css`
      ${hasAddress &&
      css`
        border-radius: ${borderRadius.l};
      `}
    `,
    facilitiesWrapper: hasAddress => css`
      background-color: ${colors.alice_blue};
      padding: 1.5rem ${spacing.s};
      margin-top: 12px;
      border-radius: ${borderRadius.l} ${borderRadius.l} 0 0;
      border: 1px solid ${colors.bright_grey};

      ${hasAddress &&
      css`
        border-radius: ${borderRadius.l} ${borderRadius.l} 0 0;
      `}
    `,
    title: css`
      color: ${colors.navy};
      text-align: center;
      font-size: 24px;

      ${breakpoints.l} {
        display: grid;
        align-content: center;
        letter-spacing: -0.01em;
        font-size: 25.9px;
      }
    `,
    subtitle: css`
      font-style: normal;
      font-size: 16px;
      line-height: 1.375rem;
      color: ${colors.darkGrey};
      text-align: center;
      padding-bottom: ${spacing.s};
      font-weight: 400;

      &::after {
        display: block;
        content: '';
        width: ${spacing.s};
        border-bottom: ${borderRadius.s} solid ${colors.red};
        margin: 5px auto 0;
      }

      ${breakpoints.l} {
        color: ${colors.darkGrey};
        font-weight: 400;
        font-size: 16px;
        font-style: normal;
        line-height: 1.375rem;
        display: grid;
        align-content: center;
        letter-spacing: 0.01em;
      }
    `,
    theLeague: css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
    `,
    fixturesTeam: css`
      display: grid;
      grid-template-columns: 1fr auto 1fr;
      text-align: center;
      margin: 0 auto;
      color: ${colors.navy};
    `,
    matcTitle: css`
      display: grid;
      align-content: center;

      &::after {
        content: '';
        position: absolute;
        left: Calc(100% - 68%);
        width: 40px;
        border-bottom: ${borderRadius.s} solid ${colors.red};
      }
    `,
    locationAddress: css`
      color: ${colors.navy};
      text-align: left;
      font-weight: 700;
      font-size: 0.875rem;

      ${breakpoints.l} {
        font-size: ${spacing.s};
        font-weight: 700;
      }
      ${breakpoints.mm_m_l}{
        font-size: 16px;
      }
      ${breakpoints.mm_s_m}{
        font-size: 16px;
      }
      ${breakpoints.mm_xs_s}{
        font-size: 16px;
      }
      ${breakpoints.mm_xxs_xs}{
        font-size: 16px;
      }
    `,
    matchAddress: css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
    `,
    mapIcon: css`
      margin-top: 4px;
      background: url('/images/common/team-location-pin.svg') no-repeat;
      width: 26.75px;
      height: 39.35px;
    `,
    addressContainer: css`
      display: grid;
      grid-template-columns: auto auto;
      align-items: center;
      justify-content: center;
      grid-gap: 16px;
      padding: 0 24px;
    `,
    address: css`
      margin-bottom: 12px;
      width: 100%;
      bottom: 0;
      background-color: ${colors.pale_blue};
      align-content: center;
      padding: ${spacing.s} 0 ${spacing.s} 0;
      border-radius: 0 0 ${borderRadius.l} ${borderRadius.l};
    `,
    matchDateTime: css`
      color: ${colors.darkGrey};
      font-size: 14.2px;
      font-weight: normal;

      ${breakpoints.l} {
        display: grid;
        align-content: center;
        font-size: 14.2px;
        font-weight: normal;
      }
    `,
    infoFacilities: css`
      border-radius: ${borderRadius.l} ${borderRadius.l} 0 0;
    `,
    nextFixture: css`
      position: relative;
      > div {
        font-weight: bold;
        font-size: 18px;
        color: ${colors.navy};
      }
      display: grid;
      align-items: flex-start;
      grid-row-gap: 5px;
      justify-content: center;
      grid-template-rows: minmax(80px, 80px) auto;
      justify-self: center;

      ${breakpoints.l} {
        align-items: center;
        letter-spacing: -0.01em;
        grid-template-rows: auto;
        grid-template-columns: auto auto;
        grid-row-gap: 0;
        > div {
          &:first-of-type {
            margin-right: 0.625rem;
          }
        }
      }
    `,
    imgWrapper: css`
      background-color: ${colors.white};
      border-radius: 50%;
      padding: ${spacing.s};
      height: 72px;
      width: 72px;
      margin: 0 auto;
    `,
    image: css`
      height: 40px;
      width: 34px;
    `,
    nextHome: css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      ${breakpoints.mm_m_l}{
        font-size: 1rem;
      }
      ${breakpoints.mm_s_m}{
        font-size: 1rem;
      }
      ${breakpoints.mm_xs_s}{
        font-size: 1rem;
      }
      ${breakpoints.mm_xxs_xs}{
        font-size: 1rem;
      }
    `,
    ageGroupHome: css`
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;

      ${breakpoints.l} {
        text-align: right;
      }
      ${breakpoints.mm_m_l}{
        font-size: 0.888rem;
      }
      ${breakpoints.mm_s_m}{
        font-size: 0.888rem;
      }
      ${breakpoints.mm_xs_s}{
        font-size: 0.888rem;
      }
      ${breakpoints.mm_xxs_xs}{
        font-size: 0.888rem;
      }
    `,
    nextRoad: css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      ${breakpoints.mm_m_l}{
        font-size: 1rem;
      }
      ${breakpoints.mm_s_m}{
        font-size: 1rem;
      }
      ${breakpoints.mm_xs_s}{
        font-size: 1rem;
      }
      ${breakpoints.mm_xxs_xs}{
        font-size: 1rem;
      }
    `,
    roadNameAgeGroup: css`
      text-align: center;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;

      ${breakpoints.l} {
        text-align: left;
      }
      ${breakpoints.mm_m_l}{
        font-size: 0.888rem;
      }
      ${breakpoints.mm_s_m}{
        font-size: 0.888rem;
      }
      ${breakpoints.mm_xs_s}{
        font-size: 0.888rem;
      }
      ${breakpoints.mm_xxs_xs}{
        font-size: 0.888rem;
      }
    `,
    fixturesSplit: css`
      margin: 0 5px;
      padding-top: ${spacing.s};

      ${breakpoints.l} {
        padding-top: 0;
        display: grid;
        align-items: center;
        margin: 0.625rem;
      }
    `,
    fixturesSplitVersus: css`
      margin: 0.625rem;
      font-size: 31.1px;
      font-weight: 700;

      ${breakpoints.l} {
        font-size: 31.1px;
        font-weight: 700;
        line-height: ${spacing.m};
      }
    `,
    nextFixtureName: css`
      ${breakpoints.l} {
        ${typography.headings[7].desktop};
        text-align: right;
      }
    `,
    fixturesSplitScore: css`
      background-color: ${colors.white};
      color: ${colors.navy};
      padding: 7px 10px;
      border-radius: ${borderRadius.s};
      font-size: 25.9px;
      box-shadow: 0px 2px 20px 0px #00000014;

      ${breakpoints.l} {
        ${typography.headings[7].desktop};
        font-size: 31.1px;
        margin: 0 ${spacing.s};
      }
      ${breakpoints.mm_s_m}{
        font-weight: 700;
      }
      ${breakpoints.mm_xs_s}{
        font-weight: 700;
      }
      ${breakpoints.mm_xxs_xs}{
        font-weight: 700;
      }
    `,
    roadNameWrapper: css`
      justify-content: flex-start;
      grid-template-rows: minmax(80px, 80px) auto;
      align-items: flex-start;

      ${breakpoints.l} {
        grid-template-rows: auto;
        justify-self: flex-start;
        align-items: center;
      }
    `,
    homeNameWrapper: css`
      justify-content: flex-start;
      ${breakpoints.l} {
        justify-content: flex-end;
      }
    `,
    homeNameFixture: css`
      order: 2;

      ${breakpoints.l} {
        order: unset;
      }
    `,
  };
};